import {OnlyInLoginChecker} from '../../../../../../common/checkers/OnlyInLoginChecker';
import {ScheduledLastPageFetcher} from '../../../../../../common/fetchers/ScheduledLastPageFetcher';
import {VodViewerData} from '../../../../../../graphql/generated/types';
import {ONLY_DATA_CONFIG} from '../../../../../../reactQuery/constant';
import {useViewerInfoQuery} from '../../../../../../wrapper/viewerWrapper';
import {MAX_PROGRESS_RATE} from '../constant/viewerConstant';
import {convertToLastViewRate} from '../util/convertToLastViewRate';

export interface VideoViewerProgressSyncContainerProps {
  seriesId: number;
  productId: number;
  currentTime: number;
}

/**
 * 영상 뷰어를 지원하기 위한 컨테이너입니다
 * UI 없는 컨테이너입니다. 다음 기능을 지원합니다
 * - API 로부터 마지막 읽은 rate 를 받으면 해당하는 시간을 기준으로 영상 재상 시작
 * - 갱신되는 currenTime 및 뷰어 데이터의 duration을 기준으로 rate 계산 후 마지막 페이지 API 호출
 */
export function VideoViewerProgressSyncContainer({
  seriesId,
  productId,
  currentTime,
}: VideoViewerProgressSyncContainerProps) {
  const vodViewerData = useViewerInfoQuery(
    {seriesId, productId},
    ONLY_DATA_CONFIG
  ).data?.viewerData as VodViewerData;
  const vodDownloadData = vodViewerData?.vodDownloadData;

  const rate = vodDownloadData?.duration
    ? convertToLastViewRate({
        position: currentTime,
        total: vodDownloadData.duration / 1000,
      })
    : undefined;

  return (
    <OnlyInLoginChecker>
      {rate !== undefined && (
        <ScheduledLastPageFetcher
          seriesId={seriesId}
          productId={productId}
          rate={rate}
          spineIndex={0}
          isDone={rate === MAX_PROGRESS_RATE}
        />
      )}
    </OnlyInLoginChecker>
  );
}
